import { useRef } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Conventions } from "@/components/landing/Conventions";
import { About } from "@/components/landing/About";
import { Worlds } from "@/components/landing/Worlds";
import { Gallery } from "@/components/landing/Gallery";
import { Music } from "@/components/landing/Music";
import { Trailer } from "@/components/landing/Trailer";
import { Fans } from "@/components/landing/Fans";
import { Events } from "@/components/landing/Events";
import { Booking } from "@/components/landing/Booking";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const trailerRef = useRef(null);
  const bookingRef = useRef(null);

  const scrollTo = (ref) => ref.current?.scrollIntoView({ behavior: "smooth" });

  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero onTrailer={() => scrollTo(trailerRef)} onBooking={() => scrollTo(bookingRef)} />
      <Conventions />
      <About />
      <Worlds />
      <Gallery />
      <Music />
      <Trailer ref={trailerRef} />
      <Fans />
      <Events />
      <Booking ref={bookingRef} />
      <Footer />
    </main>
  );
}
